import PropTypes from 'prop-types';
import classes from './Backdrop.module.css';

const Backdrop = ({ show, onClose, pointerOnHover }) =>
  show && (
    <div
      className={`${classes.backdrop} ${pointerOnHover ? classes.hover : ''}`}
      data-testid={`backdrop${pointerOnHover ? '-with-hover' : ''}`}
      onClick={onClose}
      onKeyPress={onClose}
      role="presentation"
    />
  );

Backdrop.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool.isRequired,
  pointerOnHover: PropTypes.bool,
};

Backdrop.defaultProps = {
  pointerOnHover: true,
  onClose: () => {},
};

export default Backdrop;
